import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { isQuizHalf } from '../lib/routes';
import instagramIcon from '../assets/social/instagram.svg';
import tiktokIcon from '../assets/social/tiktok.svg';
import xIcon from '../assets/social/x-twitter.svg';
import LanguageSwitcher from './LanguageSwitcher';
import './Footer.scss';

const PRIVACY_URL = 'https://www.primevideo.com/help?nodeId=202064890';
export const SHOW_URL =
  'https://www.primevideo.com/detail/0I4OWKAPLUWIO5013W3F3ZN952/ref=atv_sr_fle_c_srfd6f9a_1_1_1?sr=1-1&pageTypeIdSource=ASIN&pageTypeId=B0GN94PJRR&qid=1777050457101';

const SOCIALS: ReadonlyArray<{ label: string; href: string; icon: string }> = [
  { label: 'Instagram', href: 'https://www.instagram.com/offcampusonprime/', icon: instagramIcon },
  { label: 'X', href: 'https://x.com/offcampusonpv', icon: xIcon },
  { label: 'TikTok', href: 'https://www.tiktok.com/@offcampusonprime', icon: tiktokIcon },
];

export default function Footer() {
  const { t } = useTranslation();
  // The quiz half is English-only — hide the language switcher there. The empty
  // span keeps the bottom row's space-between layout (social stays right).
  const onQuizHalf = isQuizHalf(useLocation().pathname);
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <a className="site-footer__logo" href={SHOW_URL} target="_blank" rel="noreferrer">
          <img src="/img/footer-logo.png" alt="Off Campus" className="site-footer__logo-img" />
        </a>

        <nav className="site-footer__links" aria-label="Legal">
          <a href={PRIVACY_URL} target="_blank" rel="noreferrer">
            {t('footer.privacy')}
          </a>
          <span className="site-footer__copyright">{t('footer.copyright')}</span>
        </nav>

        <div className="site-footer__bottom-row">
          {onQuizHalf ? <span /> : <LanguageSwitcher />}

          <div className="site-footer__social" aria-label="Social">
            {SOCIALS.map(({ label, href, icon }) => (
              <a key={label} href={href} target="_blank" rel="noreferrer" aria-label={label}>
                <img src={icon} alt="" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
